<finxone-web-frontend-logout
  [contentStyle]="contentStyle"
  [textContentStyle]="textContentStyle"
  [logoutWidgetData]="logoutWidgetData"
  [iconSize]="iconSize"
  [iconStyle]="iconStyle"
  [isAllowedGlobalStyling]="isAllowedGlobalStyling"
  [globalStylingClass]="globalStylingClass"
></finxone-web-frontend-logout>
